var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LogWrapper',{attrs:{"order-log":_vm.orderLog}},[_vm._v(" Vertrag wurde an "+_vm._s(_vm.name)+" übertragen ")])}
var staticRenderFns = []

export { render, staticRenderFns }